import React from "react";
import { renderChip } from "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import { TransactionStatus, ReasonCode } from "../../../contract/pam.js";
import { TransactionStatusWithReasonTypeName, TransactionStatusTypeName } from "../constants.js";
function TransactionStatusChip({ status, reason }) {
  const reasonStatuses = [TransactionStatus.OnHoldRisk, TransactionStatus.OnHoldPayment];
  return reasonStatuses?.includes(status) && reason && reason !== ReasonCode.Undefined ? renderChip(`${status}.${reason}`, TransactionStatusWithReasonTypeName) : renderChip(status, TransactionStatusTypeName);
}
function renderTransactionStatus(params) {
  const props = params.value;
  return /* @__PURE__ */ React.createElement(TransactionStatusChip, { ...props });
}
export {
  renderTransactionStatus
};
//# sourceMappingURL=StatusCell.js.map
